<template>
  <div v-if="booking.status.status != 'QUOTE' && steps.length != 0">
    <v-card 
      elevation="10" 
      class="main" 
      style="border-radius: 30px;"
      >
      <v-container>
        <v-row justify="center" :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
        <v-col align="start" class="info--text">
          <p style="font-size: 22px; font-weight: bold;"> {{ booking.capturedAddress.split(', USA').join(' ') }} </p>
        </v-col>
        <v-col align="end" class="info--text">
          <p style="font-size: 18px;"> {{ booking.preferredTime == 'AM' ? `${booking.preferredDate} in the morning` : `${booking.preferredDate} in the afternoon` }} </p>
        </v-col>
      </v-row>
      </v-container>
        <v-stepper v-model="step" class="elevation-0" alt-labels flat>
            <v-stepper-header class="elevation-0 main">
            <template v-for="n in steps.length">
              <v-stepper-step
                  :key="`${n}-step`"
                  :complete="step >= n"
                  :step="n"
                  class="px-1"
              >
                <span class="info--text"> {{ steps[n - 1] }} </span>
              </v-stepper-step>
              <v-divider
                  class="info"
                  v-if="n !== steps.length"
                  :key="n"
              ></v-divider>     
            </template>
          </v-stepper-header>
          <v-stepper-header class="elevation-0 main pb-8" v-if="this.$vuetify.breakpoint.smAndDown">
            <v-row>
                <v-col align="center" v-for="n in steps.length" :key="n">
                  <span :class="step >= n ? 'primary--text' : 'info--text'"> {{ steps[n - 1] }} </span>
                </v-col>
              </v-row>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="2">
              <SchedulingBooking v-bind:booking="booking" />
              <ScheduledBooking v-bind:booking="booking" />
            </v-stepper-content>
            <v-stepper-content step="3">
              <DroppedBin v-bind:booking="booking"/>
            </v-stepper-content> 
          </v-stepper-items>
        </v-stepper>
    </v-card>
  </div>
</template>

<script>
import SchedulingBooking from '@/components/bookings/client/SchedulingBooking';
import ScheduledBooking from '@/components/bookings/client/ScheduledBooking';
import DroppedBin from '@/components/bookings/client/DroppedBin.vue';
export default {
  name: 'BookingCard',
  components: {
    SchedulingBooking,
    ScheduledBooking,
    DroppedBin,
  },
  props: {
    booking: Object,
  },
  computed: {
    steps(){
      let s = [];
      if (this.booking.vehicle.type.toLowerCase().includes('truck')) {
        s = ['Confirm order', `${this.booking.status.status == 'SCHEDULING' ? 'Scheduling' : 'Scheduled' } collection`, 'Loaded'];
      } if (this.booking.status.type == 'EXCHANGE') {
        s = ['Confirm order', `${this.booking.status.status == 'SCHEDULING' ? 'Scheduling' : 'Scheduled' } exchange`, 'Exchanged'];
      } if (this.booking.status.type == 'COLLECTION') {
        s = ['Confirm order', `${this.booking.status.status == 'SCHEDULING' ? 'Scheduling' : 'Scheduled' } collection`, 'Collected'];
      } if (this.booking.status.type == 'DELIVERY'){
        s = ['Confirm booking', `${this.booking.status.status == 'SCHEDULING' ? 'Scheduling' : 'Scheduled' } delivery`, 'Bin at location'];
      }
      return s;
    },
    step(){
      let n = 1;
      switch (this.booking.status.status) {
      case 'DROPPED':
        n = 3;
        break;
      case 'SCHEDULING':
        n = 2;
        break;
      case 'SCHEDULED':
        n = 2;
        break;
      default:
        break;
    }
    return n;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>